import type { ExpandedState } from '@tanstack/react-table';

/** A table's expanded rows by id, as the DataTable reports them. `true` (all) reads as none. */
export function expandedRowIds(next: ExpandedState): Record<string, boolean> {
  return next === true ? {} : next;
}

/**
 * The rows a reader has just opened: expanded now and not before. Collapsing turns up nothing, so
 * it never counts as viewing a row.
 *
 * Callers diff against a ref rather than rendered state: two expansions dispatched before React
 * commits would otherwise both compare to the same stale map and report the first row twice.
 */
export function newlyExpandedRowIds(previous: Record<string, boolean>, next: Record<string, boolean>): string[] {
  return Object.keys(next).filter((id) => next[id] === true && previous[id] !== true);
}
